import React, { forwardRef, useState, useImperativeHandle } from 'react';
import { Modal, View, Dimensions, Platform, StyleSheet } from 'react-native';

interface RBSheetProps {
  ref?: React.Ref<any>;
  height?: number;
  children?: React.ReactNode;
  useNativeDriver?: boolean;
  customStyles?: {
    wrapper?: any;
    container?: any;
  };
  customModalProps?: {
    animationType?: 'none' | 'slide' | 'fade';
    statusBarTranslucent?: boolean;
  };
  customAvoidingViewProps?: {
    enabled?: boolean;
  };
  onOpen?: () => void;
  onClose?: () => void;
}

const RBSheetWeb = forwardRef<any, RBSheetProps>(
  (
    {
      height = Dimensions.get('window').height * 0.65,
      children,
      customStyles = {},
      customModalProps = {},
      onOpen,
      onClose,
    },
    ref
  ) => {
    const [isVisible, setIsVisible] = useState(false);

    useImperativeHandle(ref, () => ({
      open: () => {
        setIsVisible(true);
        onOpen?.();
      },
      close: () => {
        setIsVisible(false);
        onClose?.();
      },
    }));

    // On web, use Modal; on native, render nothing (native will use actual RBSheet)
    if (Platform.OS === 'web') {
      return (
        <Modal
          visible={isVisible}
          transparent={true}
          animationType={customModalProps.animationType || 'fade'}
          onRequestClose={() => {
            setIsVisible(false);
            onClose?.();
          }}>
          <View style={[styles.wrapper, customStyles.wrapper]}>
            <View
              style={[
                styles.container,
                { height },
                customStyles.container,
              ]}>
              {children}
            </View>
          </View>
        </Modal>
      );
    }

    // On native, return nothing - the real RBSheet will be used
    return null;
  }
);

RBSheetWeb.displayName = 'RBSheetWeb';

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  container: {
    backgroundColor: '#fff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    overflow: 'hidden',
  },
});

export default RBSheetWeb;
